module.exports = __webpack_public_path__ + "img/nfpoa-tela04_corte.8dc791e5.png";